/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeSize } from './SafeSize';
import {
    SafeSizeFromJSON,
    SafeSizeFromJSONTyped,
    SafeSizeToJSON,
    SafeSizeToJSONTyped,
} from './SafeSize';
import type { SafeLocation } from './SafeLocation';
import {
    SafeLocationFromJSON,
    SafeLocationFromJSONTyped,
    SafeLocationToJSON,
    SafeLocationToJSONTyped,
} from './SafeLocation';

/**
 * The raw, user-editable Safe Deposit Box fields, kept separate from SafeDepositBoxServiceAgreementProperties so schemas that only need these fields (e.g. the service-role bulk-sync request) aren't dragged into the ProductSpecificServiceAgreementProperties oneOf/discriminator - referencing that discriminated schema directly from a concretely-typed field confuses Jackson's type-id resolution for that field (it falls back to the class name instead of the registered discriminator value).
 * 
 * @export
 * @interface SafeDepositBoxFields
 */
export interface SafeDepositBoxFields {
    /**
     * 
     * @type {SafeLocation}
     * @memberof SafeDepositBoxFields
     */
    safeLocation?: SafeLocation;
    /**
     * 
     * @type {SafeSize}
     * @memberof SafeDepositBoxFields
     */
    safeSize?: SafeSize;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxFields
     */
    safeNr?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SafeDepositBoxFields
     */
    keyDeposit?: boolean;
}



/**
 * Check if a given object implements the SafeDepositBoxFields interface.
 */
export function instanceOfSafeDepositBoxFields(value: object): value is SafeDepositBoxFields {
    return true;
}

export function SafeDepositBoxFieldsFromJSON(json: any): SafeDepositBoxFields {
    return SafeDepositBoxFieldsFromJSONTyped(json, false);
}

export function SafeDepositBoxFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxFields {
    if (json == null) {
        return json;
    }
    return {
        
        'safeLocation': json['safeLocation'] == null ? undefined : SafeLocationFromJSON(json['safeLocation']),
        'safeSize': json['safeSize'] == null ? undefined : SafeSizeFromJSON(json['safeSize']),
        'safeNr': json['safeNr'] == null ? undefined : json['safeNr'],
        'keyDeposit': json['keyDeposit'] == null ? undefined : json['keyDeposit'],
    };
}

export function SafeDepositBoxFieldsToJSON(json: any): SafeDepositBoxFields {
    return SafeDepositBoxFieldsToJSONTyped(json, false);
}

export function SafeDepositBoxFieldsToJSONTyped(value?: SafeDepositBoxFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'safeLocation': SafeLocationToJSON(value['safeLocation']),
        'safeSize': SafeSizeToJSON(value['safeSize']),
        'safeNr': value['safeNr'],
        'keyDeposit': value['keyDeposit'],
    };
}

